import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { ClientService } from '../../core/api/client.service';
import { PopupService } from '../../shared/popup/popup.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    TranslateModule
],
  templateUrl: './contact.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact.component.css',
})
export class ContactComponent implements OnInit {
  private fb = inject(FormBuilder);
  private readonly service = inject(ClientService);
  private readonly popup = inject(PopupService);
  private translate = inject(TranslateService);

  contactForm!: FormGroup;
  submitting = false;

  contactTypes = [
    { value: 'contact', viewValue: 'General Inquiry' },
    { value: 'support', viewValue: 'Technical Support' },
    // { value: 'sla', viewValue: 'Service Agreement' },
  ];

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      type: ['', Validators.required],
      description: ['', [Validators.required, Validators.minLength(10)]],
    });
  }

  onSubmit(): void {
    if (this.contactForm.invalid || this.submitting) return;

    this.submitting = true;
    this.service.contact.createSupportTicket(this.contactForm.value).subscribe({
      next: () => {
        this.submitting = false;
        this.popup.notify('home.product.contact.form.success');
        this.contactForm.reset();
      },
      error: () => {
        this.submitting = false;
        this.popup.notify('lib.errors.common');
      }
    });
  }
}
